import { useApplicationContext } from "src/hooks/useApplication";
import { useEntityContext } from "../useEntityContext";
import { EntityScreen } from "./components/layout/Screen";
import { HeaderPanel } from "./components/layout/HeaderPanel";
import { SummaryPanel } from "./components/layout/SummaryPanel";
import { InsightsPanel } from "./components/layout/InsightsPanel";
import { toHeaderAttributes } from "./components/HeaderAttributes";
import { EntityTabs } from "./components/EntityTabs";
import { ActionCard } from "./components/ActionCard";
import { SummaryTag } from "./components/Tags";
import { SentencesList } from "./components/SentencesList";
import { Work, WorkComponent } from "../Work";
import { Insights } from "../Insights";

export const TimeinStatusEntity = () => {
  const orgId = useApplicationContext().org_id!;
  const context = useEntityContext();
  const entity = context.dataRef.current.entity.properties;
  const entityType = context.dataRef.current.entity.labels[0];
  return (
    <EntityScreen
      headerPanel={
        <HeaderPanel
          label={entity.name}
          entity={context.dataRef.current.entity}
          attributes={toHeaderAttributes({
            orgId,
            context,
            entityType,
            attributes: [{ name: "uuid", text: entity.uuid }],
          })}
        />
      }
      summaryPanel={
        <SummaryPanel
          title={entity.name}
          description={entity.description || entity.title}
        />
      }
      insightsPanel={
        <InsightsPanel
          cards={[
            entity.vzblValueStatement && (
              <ActionCard
                key="value-statement"
                badge={<SummaryTag />}
                label="Value Statement"
                value={<SentencesList data={entity.vzblValueStatement} />}
              />
            ),
          ].filter(Boolean)}
        />
      }
    >
      <EntityTabs
        propertiesSkipList={[
          "name",
          "title",
          "description",
          "vzblValueStatement",
        ]}
        entity={context.dataRef.current.entity}
        tabs={useTimeInStatusTabs(context.dataRef.current.entity)}
      />
    </EntityScreen>
  );
};

function useTimeInStatusTabs(entity: any) {
  const orgId = useApplicationContext().org_id!;
  return [
    {
      key: "overview",
      id: "overview",
      label: "Overview",
      children: <Insights entity={entity} />,
    },
    {
      key: "2",
      id: "2",
      label: "Work",
      children: (
        <>
          <Work
            orgId={orgId}
            entityUuid={entity.properties.uuid}
            types={["Issue"]}
          >
            <WorkComponent title="Related Issue" />
          </Work>
        </>
      ),
    },
  ];
}
